import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MainTempService {

  constructor() { }

  headerHeight: number = 56;

  set(headerHeight: number) {
    this.headerHeight = headerHeight;
  }
}
